/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { DataGrid, GridColDef } from "@mui/x-data-grid";

import {
  Alert,
  Box,
  Button,
  Card,
  debounce,
  Grid,
  IconButton,
  LinearProgress,
  Pagination,
  Paper,
  Snackbar,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import TemporaryDrawer from "./FilterOption";
import image from "../../images/Download_icon.png";
import { AppDispatch, RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";
import {
  fetchFilterCounts,
  getAvailableProducts,
  getAvailableRegions,
  getTenantExportList,
  getTenantList,
  deleteTenant,
  getForgeCustomeIdTenantData,
  getGeoMapping,
} from "../../store/Tenant/tenant-actions";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import classes from "./FilterOptions.module.css";
import { Application, GeoMapping, IErrorProps, Tenant } from "../../models";
import * as XLSX from "xlsx";
import RefreshIcon from "@mui/icons-material/Refresh";

import QuickSearchToolbar from "../SharedComponents/QuickSearchToolbar";
import updateErrorList from "../../utils/methods/updateErrorList";
import DialogForError from "../SharedComponents/DialogForError";
import ToastBarForError from "../SharedComponents/ToastBarForError";
import UserPermissions from "../../models/apiModels/UserPermissions";
import { getUserPermissions } from "../../store/User/user-actions";
import { ConfigurationVariables } from "../../config";
import FilterJson from "../../models/FilterJson";
import DeleteDialog from "../SharedComponents/DeleteDialog";
import { getLocalTime } from "../../utils/methods/getLocalTime";
import { getNoRowsLabel } from "../../utils/methods/getNoRowsLabel";
import { tenantActions } from "../../store/Tenant/tenant-slice";
import { userActions } from "../../store/User/user-slice";

function TenantListwithFilters() {
  const dispatch: AppDispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const toastErrors = useRef<IErrorProps[]>([]);
  // stores prev value of search text
  // Fetching loaders
  const [isFetching, setIsFetching] = useState(false);
  const [isFetchingTenants, setIsFetchingTenants] = useState(false);
  const [isFetchingUserPermissions, setIsFetchingUserPermissions] =
    useState(false);
  const [isFetchingApplications, setIsFetchingApplications] = useState(false);
  const [isFetchingRegions, setIsFetchingRegions] = useState(false);
  const [isFetchingFilters, setIsFetchingFilters] = useState(false);
  // End fetching loaders
  const [isLoading, setIsLoading] = useState(false);
  const [errorList, setErrorList] = useState<Array<IErrorProps>>([]);
  const [errorExport, seterrorExport] = useState<Array<IErrorProps>>([]);
  const [errorDelete, seterrorDelete] = useState<Array<IErrorProps>>([]);
  const [errorGetAllTenants, seterrorGetAllTenants] = useState<
    Array<IErrorProps>
  >([]);
  const [errorGeoMapping, seterrorGeoMapping] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);
  const [filteringCritera, setFilteringCriteria] = useState<FilterJson>({
    assignedApps: [],
    region: [],
  });

  const optionsRegion = useSelector(
    (state: RootState) => state.cart.availableRegions
  );

  const optionsProductList = useSelector(
    (state: RootState) => state.cart.availableProducts
  );
  const totalData = useSelector((state: RootState) => state.cart.totalQuantity);

  const [gridRowCount, setgridRowCount] = useState<number>(0);
  const [gridPageData, setGridPageData] = useState<Array<Tenant>>([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 1,
    pageSize: 10,
  });

  const navigate = useNavigate();
  const [deleteTenantData, setDeleteTenantData] = useState<any>();

  const tenantData = useSelector((state: RootState) => state.cart.tenants);
  const optionsGeoMapping: GeoMapping = useSelector(
    (state: RootState) => state.cart.geoMapping
  );

  const canEffectForFilterRun = useRef(false);
  const canEffectForSearchRun = useRef(false);

  // The Effect when paginationModel.page is a dependency runs even during search , filter
  // when page no from where we filter, search is not 1
  // as after search, filter -> page no becomes 1 and the effect runs
  // To  avoid that adding :
  const shouldPageChangeEffectRun = useRef(true);

  // Check if refresh button is clicked
  const isRefreshButtonClicked = useRef(false);

  const userPermissionFetched = useSelector(
    (state: RootState) => state.user.isUserPermissionsFetched
  );

  const userPermissions: UserPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );

  const [regionFilterCriteria, setRegionFilterCriteria] = useState<
    Array<string>
  >([]);

  const [appFilterCriteria, setAppFilterCriteria] = useState<Array<string>>([]);
  const currentTenantIdOfLoadedUsers = useSelector(
    (state: RootState) => state.cart.currentTenantIdOfLoadedUsers
  );

  const getPageEndCount = () => {
    if (gridRowCount - paginationModel.page * paginationModel.pageSize >= 0) {
      return paginationModel.page * paginationModel.pageSize;
    } else if (gridRowCount < paginationModel.pageSize) {
      return gridRowCount;
    } else {
      return paginationModel.page * paginationModel.pageSize - 1;
    }
  };
  // Effect runs when filtering condition changes
  useEffect(() => {
    setAppFilterCriteria(filteringCritera.assignedApps);
    setRegionFilterCriteria(filteringCritera.region);
  }, [filteringCritera]);

  // Get availlable regions if not present
  useEffect(() => {
    if (optionsRegion?.length === 0) {
      setIsFetchingRegions(true);
      dispatch(getAvailableRegions())
        .unwrap()
        .catch((error: any) => {
          setErrorList((prevState) => updateErrorList(error, [...prevState]));
        })
        .finally(() => setIsFetchingRegions(false));
    }
  }, []);

  useEffect(() => {
    if (optionsProductList?.length === 0) {
      setIsFetchingApplications(true);

      dispatch(getAvailableProducts())
        .unwrap()
        .catch((error: any) => {
          setErrorList((prevState) => updateErrorList(error, [...prevState]));
        })
        .finally(() => setIsFetchingApplications(false));
    }
  }, []);

  // API call wrt Pagination call for each page

  useEffect(() => {
    let active = true;
    (async () => {
      const parameters: {
        pageNumber: number;
        pageSize: number;
        searchText: string;
        finalFilterData: FilterJson;
      } = {
        pageNumber: paginationModel.page,
        pageSize: paginationModel.pageSize,
        searchText: searchText,
        finalFilterData: filteringCritera,
      };
      // To avoid this call during Refresh button click
      if (isRefreshButtonClicked.current) {
        isRefreshButtonClicked.current = false;
        return;
      }
      //If user permissions are not fetched Fetch the permissions
      //For Logged in User before performing any action
      if (!userPermissionFetched) {
        setIsFetchingUserPermissions(true);
        dispatch(getUserPermissions())
          .unwrap()
          // istanbul ignore next
          .then((response) => {
            const userPermissionsResponse: UserPermissions = response.result;
            //If the user is tenant admin then redirecting him to tenant user page
            if (
              !userPermissionsResponse.can_read_tenant &&
              userPermissionsResponse.can_read_user
            ) {
              getForgeCustomerIdTenantData_handleDispatch();
            } else if (userPermissionsResponse.can_read_tenant) {
              getTenantList_handleDispatch(parameters);
            } else {
              handleError_IfPrivilegeNotPresentForUser(
                "User doesn't have privileges to List the Tenants"
              );
            }
          })
          .catch((err: any) => {
            seterrorGetAllTenants(
              updateErrorList(err, [...errorGetAllTenants])
            );
          })
          .finally(() => setIsFetchingUserPermissions(false));
      } else {
        //If the user is tenant admin then redirecting him to tenant user page
        if (!userPermissions.can_read_tenant && userPermissions.can_read_user) {
          getForgeCustomerIdTenantData_handleDispatch();
        }

        // shouldPageChangeEffectRun.current is so that this effect does not run during initial search and initial filter
        // istanbul ignore next
        else if (userPermissions.can_read_tenant) {
          if (shouldPageChangeEffectRun.current) {
            getTenantList_handleDispatch(parameters);
          }
          // istanbul ignore next
        } else {
          handleError_IfPrivilegeNotPresentForUser(
            "User doesn't have privileges to List the Tenants"
          );
        }
      }
      // istanbul ignore next
      if (!active) {
        return;
      }
    })();
    return () => {
      active = false;
    };
  }, [paginationModel.page]);
  // End Datagrid code
  // Get filter values:

  useEffect(() => {
    let active = true;
    (async () => {
      //If user permissions are not fetched Fetch the permissions
      //For Logged in User before performing any action
      if (!userPermissionFetched) {
        setIsFetchingUserPermissions(true);
        dispatch(getUserPermissions())
          .unwrap()
          // istanbul ignore next
          .then((response) => {
            const userPermissionsResponse: UserPermissions = response.result;
            if (userPermissionsResponse.can_read_tenant) {
              fetchFilterCounts_handleDispatch();
            } else {
              handleError_IfPrivilegeNotPresentForUser(
                "User doesn't have privileges to List the Tenants"
              );
            }
          })
          .catch((err: any) => {
            seterrorGetAllTenants(
              updateErrorList(err, [...errorGetAllTenants])
            );
            let errorCode = err.status;
            if (errorCode == 401) {
              navigate("/error");
            }
          })
          .finally(() => setIsFetchingUserPermissions(false));
      } else {
        if (userPermissions.can_read_tenant) {
          fetchFilterCounts_handleDispatch();
        } else {
          handleError_IfPrivilegeNotPresentForUser(
            "User doesn't have privileges to List the Tenants"
          );
        }
      }
      if (!active) {
        return;
      }
    })();

    return () => {
      active = false;
    };
  }, []);
  // Get filter values end

  useEffect(() => {
    setGridPageData(tenantData);
  }, [filteringCritera, tenantData]);

  // Debounce logic
  // istanbul ignore next
  useEffect(() => {
    // Guard clause for Refresh button
    if (isRefreshButtonClicked.current) {
      return;
    }
    if (!canEffectForSearchRun.current) {
      canEffectForSearchRun.current = true;
    } else if (
      userPermissionFetched &&
      userPermissions.can_read_tenant &&
      canEffectForSearchRun.current
    ) {
      shouldPageChangeEffectRun.current = false;
      const debouncedAPICall = debounce(() => {
        getGridDataWhenSearchTextChanges();
      }, ConfigurationVariables.DebounceTime_InMilliSeconds); // Adjust the debounce delay as needed Make it configurable
      debouncedAPICall();

      // Cleanup the debounce function on component unmount
      return () => {
        debouncedAPICall.clear();
      };
    } else {
    }
  }, [searchText]);

  // API call on filtering

  useEffect(() => {
    if (!canEffectForFilterRun.current) {
      canEffectForFilterRun.current = true;
    } else if (userPermissionFetched && userPermissions.can_read_tenant) {
      shouldPageChangeEffectRun.current = false;
      getGridDataWhenSearchTextChanges();
    }
  }, [filteringCritera]);
  useEffect(() => {
    const mergedErrors = [
      ...errorDelete,
      ...errorGetAllTenants,
      ...errorExport,
    ];
    if (
      mergedErrors.some((x) => x.errorCode === undefined) &&
      !openDialogNoURLError
    ) {
      setOpenDialogNoURLError(true);
    }
    if (mergedErrors.some((x) => x.errorCode === 400) && !openToastError) {
      setOpenToastError(true);
    }
    if (
      mergedErrors.some(
        (x) =>
          x.errorCode !== undefined &&
          x.errorCode !== 400 &&
          x.errorCode !== null &&
          x.errorCode !== 204
      ) &&
      !openDialogServerError
    ) {
      setOpenDialogServerError(true);
    }
    setErrorList(mergedErrors);
  }, [errorDelete, errorGetAllTenants, errorExport]);

  // This effect checks if loading indicator should be visible or not
  useEffect(() => {
    // fetchingTenants is independent. It affects datagrid , so not part of this logic
    if (
      !isFetching &&
      !isFetchingUserPermissions &&
      !isFetchingApplications &&
      !isFetchingRegions &&
      !isFetchingFilters
    ) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [
    isFetching,
    isFetchingUserPermissions,
    isFetchingApplications,
    isFetchingRegions,
    isFetchingFilters,
  ]);

  const [progress, setProgress] = useState(0);
  const [toastOpen, settoastOpen] = useState(false);
  function getGridDataWhenSearchTextChanges() {
    const parameters: {
      pageNumber: number;
      pageSize: number;
      searchText: string;
      finalFilterData: FilterJson;
    } = {
      pageNumber: 1,
      pageSize: paginationModel.pageSize,
      searchText: isRefreshButtonClicked.current ? "" : searchText,
      finalFilterData: filteringCritera,
    };
    getTenantList_handleDispatch(parameters);
  }

  // istanbul ignore next
  const downloadExcel = async () => {
    setIsFetching(true);
    dispatch(getTenantExportList())
      .unwrap()
      // istanbul ignore next
      .then(async (data) => {
        settoastOpen(true);
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        let currentDate = new Date().toJSON().slice(0, 10);
        const fileData = XLSX.writeFile(
          workbook,
          `UDP_Admin-Tenant-Management-${currentDate}.xlsx`
        );
        const blob = new Blob([fileData], { type: "application/octet-stream" });
        const url = URL.createObjectURL(blob);
        const response = await fetch(url);
        const contentLength = response.headers.get("content-length") ?? "100";

        const total = parseInt(contentLength, 10);
        const reader = response.body?.getReader();
        if (!reader) {
          URL.revokeObjectURL(url);
          return;
        }

        let loaded = 0;

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          loaded += value.length;
          const percent = Math.round((loaded / total) * 100);
          setProgress(percent);
        }
        URL.revokeObjectURL(url);
        // TO-DO : remove the animation for setting value back to zero
        await new Promise((resolve) => setTimeout(resolve, 2500));
        settoastOpen(false);
        setProgress(0);
      })
      .catch((error: any) => {
        seterrorExport(updateErrorList(error, [...errorExport]));
      })
      .finally(() => setIsFetching(false));
  };

  useEffect(() => {
    if (optionsGeoMapping?.countryDataMap?.length === 0) {
      setIsLoading(true);
      dispatch(getGeoMapping())
        .unwrap()
        .then((response) => {})
        .catch((error: any) => {
          seterrorGeoMapping(updateErrorList(error, [...errorGeoMapping]));
        })
        .finally(() => setIsLoading(false));
    }
  }, []);

  let products: Application[] = [];

  const applications: string[] = products?.map(
    (product) => product.applicationName
  );

  const mappedApplication = applications.filter(
    (value: any, index: any, self: string | any[]) =>
      self.indexOf(value) === index
  );

  dispatch(tenantActions.showFilteredList(mappedApplication));

  const columns: GridColDef[] = [
    {
      field: "tenantName",
      headerName: "NAME",
      flex: 1,
      renderCell: (cellValues: any) => {
        return (
          <Tooltip title={cellValues.row.tenantName} placement="bottom-start">
            <Link
              onClick={() => {
                // Reset the tenant users and tennatIdOfloadedusers if selected tenant is not same as previously selected tenant
                if (cellValues.row.id !== currentTenantIdOfLoadedUsers) {
                  dispatch(userActions.resetUserListBasedOnForgeCustomerId());
                  dispatch(tenantActions.getCurrentTenantIdOfLoadedUsers(""));
                }
              }}
              to="/tenant/user"
              state={cellValues.row}
              style={{ color: "#64C3FF", textDecoration: "none" }}
            >
              {cellValues.row.tenantName}
            </Link>
          </Tooltip>
        );
      },
    },

    {
      field: "products",
      headerName: "PURCHASED APPS",
      sortable: false,
      flex: 2,
      valueGetter: (params) => {
        let result = [];
        if (params?.row?.products?.length > 0) {
          result = params?.row?.products?.map(
            (product: Application) => product?.applicationName
          );
        }
        return result;
      },
    },
    { field: "region", headerName: "REGION", flex: 1 },
    {
      field: "createdon",
      headerName: "CREATION DATE",
      flex: 1,
      renderCell: (cellValues: any) => {
        return getLocalTime({
          utcTime: cellValues?.row?.createdon,
          timezone: cellValues?.row?.timezone,
        });
      },
    },
    {
      field: "ACTION",
      flex: 1,
      sortable: false,
      renderCell: (cellValues: any) => {
        return (
          <div>
            <Button
              sx={{
                fontSize: "0.8rem",
                padding: 0,
                justifyContent: "start",
                color: "#64C3FF",
                textTransform: "none",
                fontFamily: "Honeywell Sans Web",
              }}
              color="primary"
              onClick={(event) => {
                handleEdit(event, cellValues);
              }}
            >
              Edit
            </Button>
            <Button
              sx={{
                fontSize: "0.8rem",
                padding: 0,
                justifyContent: "start",
                color: "#64C3FF",
                textTransform: "none",
                fontFamily: "Honeywell Sans Web",
              }}
              variant="text"
              color="primary"
              onClick={(event) => {
                handleDelete(event, cellValues);
              }}
            >
              Delete
            </Button>
          </div>
        );
      },
    },
  ];

  function resetGridPageData() {
    setGridPageData([]);
    setgridRowCount(0);
  }

  const handleEdit = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    cellValues: { row: any }
  ) => {
    if (userPermissions.can_update_tenant) {
      navigate(`/tenant/edit/${cellValues.row.id}`, {
        state: { editTenantDetails: cellValues.row },
      });
    } else {
      handleError_IfPrivilegeNotPresentForUser(
        "User doesn't have privileges to Update Tenant"
      );
    }
  };

  const handleDelete = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    cellValues: { row: any }
  ) => {
    if (userPermissions.can_delete_tenant) {
      setDeleteTenantData(cellValues?.row);
      setOpen(true);
    } else {
      handleError_IfPrivilegeNotPresentForUser(
        "User doesn't have privileges to Delete the Tenant"
      );
    }
  };

  const handleClose = () => {
    setDeleteTenantData(null);
    setOpen(false);
  };
  const handleCloseToast = () => {
    settoastOpen(false);
  };
  //while clicking on delete button
  // istanbul ignore next

  const handleDeleteConfirmation = () => {
    let tenant = deleteTenantData;
    setIsFetching(true);
    setOpen(false);
    dispatch(deleteTenant(tenant.id as string))
      .unwrap()
      .then(() => {
        setDeleteTenantData(null);
        setIsFetchingFilters(true);
        fetchFilterCounts_handleDispatch();
      })
      .catch((err: any) =>
        seterrorDelete(updateErrorList(err, [...errorDelete]))
      )
      .finally(() => {
        setIsFetching(false);
      });
    setOpen(false);
  };

  //getPageValues
  // istanbul ignore next

  const getPageValues = (event: React.ChangeEvent<unknown>, page: number) => {
    setPaginationModel({ ...paginationModel, page: page });
    shouldPageChangeEffectRun.current = true;
  };

  const getApplicationNamefromId = (id: string) => {
    return optionsProductList.find((x) => x.applicationId === id)
      ?.applicationName;
  };
  // istanbul ignore next
  //to create new tenant
  const handleCreateNewTenant = () => {
    if (userPermissions.can_create_tenant) {
      navigate("/tenant/create");
    } else {
      // Pass Error message;
      handleError_IfPrivilegeNotPresentForUser(
        "User doesn't have privileges to create tenant"
      );
    }
  };
  // istanbul ignore next
  //on changing search text
  const searchOnchange = (event: React.ChangeEvent<HTMLInputElement>) => {
    isRefreshButtonClicked.current = false;
    setSearchText(event.target.value);
  };
  // istanbul ignore next
  // get forge customer id in case of  refresh/ new page
  const getForgeCustomerIdTenantData_handleDispatch = () => {
    dispatch(getForgeCustomeIdTenantData())
      .unwrap()
      // istanbul ignore next
      .then((response) => {
        setIsLoading(true);
        navigate("/tenant/user", {
          state: response,
        });
      })
      .catch((err: any) => {})
      .finally(() => setIsLoading(false));
  };
  // istanbul ignore next
  //fetch Filter Counts handlling Dispatch
  const fetchFilterCounts_handleDispatch = () => {
    setIsFetchingFilters(true);

    dispatch(fetchFilterCounts())
      .unwrap()
      .catch((error: any) => {
        seterrorGetAllTenants(updateErrorList(error, [...errorGetAllTenants]));
      })
      .finally(() => setIsFetchingFilters(false));
  };
  // istanbul ignore next
  //handle get tenant list dispatch
  const getTenantList_handleDispatch = (parameters: any) => {
    setIsFetchingTenants(true);
    dispatch(getTenantList(parameters))
      .unwrap()
      .then((response) => {
        if (response?.tenants?.length >= 0) {
          setGridPageData(response?.tenants);
        } else {
          resetGridPageData();
        }
        setgridRowCount(response?.totalCount);
      })
      .catch((error: any) => {
        resetGridPageData();
        seterrorGetAllTenants(updateErrorList(error, [...errorGetAllTenants]));
      })
      .finally(() => setIsFetchingTenants(false));
  };

  const handleError_IfPrivilegeNotPresentForUser = (errorMessage: string) => {
    const error: IErrorProps = {
      errorCode: 403,
      errorMessage: errorMessage,
    };
    const errorList: IErrorProps[] = [];
    errorList.push(error);
    setErrorList(errorList);
    setOpenToastError(true);
  };

  // Error props handlers
  const onDialogForServerCloseHandler = () => setOpenDialogServerError(false);
  const onDialogForNOURLCloseHandler = () => setOpenDialogNoURLError(false);

  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };
  // End Error props handlers

  const customLocaleText = {
    noRowsLabel: getNoRowsLabel(
      searchText,
      filteringCritera.assignedApps.length !== 0 ||
        filteringCritera.region.length !== 0
    ),
  };

  const filteringCriteriaChangeHandler = (dataFromFilter: FilterJson) => {
    setFilteringCriteria(dataFromFilter);
  };
  // istanbul ignore next
  //remove filter for Other pages
  const removeFilter = (item: string, filterType: "app" | "region") => {
    let updatedfilterCriteria = { ...filteringCritera };

    setFilteringCriteria({
      ...updatedfilterCriteria,
      assignedApps: updatedfilterCriteria.assignedApps.filter((x) =>
        filterType === "region" ? x : x != item
      ),
      region: updatedfilterCriteria.region.filter((x) =>
        filterType === "app" ? x : x != item
      ),
    });
  };

  return (
    <>
      <Paper sx={{ minWidth: "600px" }} className={classes.paper}>
        <div>
          <Grid container direction="column" p={2} borderColor="black">
            <Grid
              container
              direction="row"
              sx={{ paddingBottom: "1vh", minWidth: "600px" }}
            >
              <Box className={classes.heading}> Tenants </Box>
              <Box marginLeft={2} marginRight={2} sx={{ fontSize: "1rem" }}>
                |
              </Box>
              <Snackbar
                open={toastOpen}
                onClose={handleCloseToast}
                sx={{ width: "30%" }}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              >
                <Alert
                  severity="info"
                  onClose={handleCloseToast}
                  className={classes.exportToast}
                >
                  <Grid md={12}>
                    <Typography
                      sx={{ width: "200px", padding: " 5 0 5 0" }}
                      className={classes.exportToastMessage}
                    >
                      Datasheet.xslx
                    </Typography>
                    <LinearProgress
                      sx={{
                        width: "100%",
                        borderRadius: "4px 2px 2px 4px",
                        backgroundColor: "#707070",
                      }}
                      variant="determinate"
                      value={progress}
                    />
                    <Typography
                      color="inherit"
                      sx={{ width: "200px" }}
                      className={classes.exportToastMessage}
                    >
                      Downloading...
                    </Typography>
                  </Grid>
                </Alert>
              </Snackbar>
              <Box className={classes.totalCount}>
                {totalData === 1 ? (
                  <span>Total 1 Tenant</span>
                ) : (
                  <span>Total {totalData} Tenants</span>
                )}
              </Box>
              <Box
                sx={{
                  marginLeft: "auto",
                  alignItems: "flex-end",
                  textAlign: "flex-end",
                  paddingRight: "5vh",
                }}
              >
                <Button
                  variant="contained"
                  onClick={handleCreateNewTenant}
                  className={classes.createtenant}
                >
                  Create New Tenant
                </Button>
              </Box>
            </Grid>
            <Card
              sx={{
                background: "#272727",
                border: "1px solid #101010",
                boxShadow: " 1px 1px 1px rgba(0, 0, 0, 0.15)",
                borderRadius: "0.7vw",
                minWidth: "600px",
              }}
            >
              <Box
                p="2vh"
                paddingLeft="1.5vw"
                sx={{ background: "#313030", height: "5vh" }}
              >
                <div className={classes.secondaryHeading}>tenants list</div>
              </Box>

              <Grid
                item
                sx={{
                  background: "#272727",
                  border: " 0.1 solid #101010",
                  minWidth: "600px",
                }}
              >
                <Grid container direction="row">
                  <Grid
                    item
                    sx={{
                      padding: "1.4vh",
                      paddingTop: "1.9vh",
                    }}
                  >
                    <TemporaryDrawer
                      isFilterDisabled={isFetchingTenants || isLoading}
                      filteringCritera={filteringCritera}
                      onFilteringCriteriaChange={filteringCriteriaChangeHandler}
                    />
                  </Grid>
                  <Grid item sx={{ padding: "1.4vh" }}>
                    <QuickSearchToolbar
                      isDisabled={
                        isLoading ||
                        isFetchingTenants ||
                        (searchText === "" && totalData === 0)
                      }
                      value={searchText}
                      placeHolderMessage="Search Tenant/Region"
                      //  onChange = {searchOnchange}
                      onChange={(event: any) => searchOnchange(event)}
                    ></QuickSearchToolbar>
                  </Grid>
                  <Grid
                    p={1}
                    sx={{
                      marginLeft: "auto",
                      alignItems: "initial",
                      textAlign: "initial",

                      backgroundColor: "#272727",
                      padding: "1.4vh",
                      paddingRight: "5vh",
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={0}
                      sx={{ flexDirection: "row-reverse", height: "5vh" }}
                    >
                      <Tooltip title="Refresh List">
                        <Button
                          data-testid="refreshButton"
                          onClick={() => {
                            isRefreshButtonClicked.current = true;
                            setSearchText("");
                            if (
                              !(
                                filteringCritera?.assignedApps.length === 0 &&
                                filteringCritera?.region.length === 0
                              )
                            ) {
                              setFilteringCriteria({
                                assignedApps: [],
                                region: [],
                              });
                            }

                            // Need to discard search when Refresh button is enabled
                            getGridDataWhenSearchTextChanges();
                            // Changing it back to false  for: Guard clause to allow useEffect for pginationModel.model
                            setIsFetchingFilters(true);
                            fetchFilterCounts_handleDispatch();
                          }}
                          className={classes.refreshButton}
                          sx={{ marginTop: "0.5vh", marginBottom: "1vh" }}
                        >
                          <RefreshIcon
                            sx={{
                              color: "#F0F0F0",
                              fontSize: "2vw",
                              paddingTop: 0,
                            }}
                          />
                        </Button>
                      </Tooltip>
                      <Tooltip title="Download list of all Tenants">
                        <Button
                          onClick={() => downloadExcel()}
                          data-testid="downloadExcel"
                          sx={{
                            marginTop: "0.8vh",
                            marginBottom: "1vh",
                          }}
                        >
                          <img
                            src={image}
                            alt="Button Icon"
                            style={{
                              width: "2vw",
                              paddingTop: 0,
                              paddingBottom: 0,
                            }}
                          />
                        </Button>
                      </Tooltip>
                    </Stack>
                  </Grid>
                  {/* <Grid item  md={7}  p={1} > */}

                  {/* </Grid> */}
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                sx={{
                  textAlign: "left",
                  background: "#272727",
                  border: "1px solid #101010",
                  fontSize: "0.2 rem",
                  padding: "0.5vh",
                  width: "auto",
                }}
              >
                {regionFilterCriteria.length === 0 &&
                appFilterCriteria.length === 0 ? (
                  <Grid item className={classes.nofilter}>
                    No filters applied
                  </Grid>
                ) : (
                  regionFilterCriteria.map((item) => (
                    <Grid item className={classes.filterChips}>
                      {item}
                      <IconButton
                        className={classes.filterCloseIcon}
                        onClick={() => {
                          removeFilter(item, "region");
                        }}
                        data-testid="imageEdit"
                      >
                        <CloseIcon sx={{ fontSize: "0.9rem" }} />
                      </IconButton>
                    </Grid>
                  ))
                )}

                {regionFilterCriteria.length === 0 &&
                appFilterCriteria.length === 0 ? (
                  <div></div>
                ) : (
                  appFilterCriteria.map((item) => (
                    <Grid item className={classes.filterChips}>
                      <>
                        {getApplicationNamefromId(item)}
                        <IconButton
                          className={classes.filterCloseIcon}
                          onClick={() => {
                            removeFilter(item, "app");
                          }}
                          data-testid="imageEdit"
                        >
                          <CloseIcon sx={{ fontSize: "0.9rem" }} />
                        </IconButton>
                      </>
                    </Grid>
                  ))
                )}
              </Grid>
              <Grid item md={12}>
                <div
                  style={{
                    height: "52vh",
                    background: "#272727",
                    fontSize: 8,
                    width: "94vw",
                  }}
                >
                  <DataGrid
                    columns={columns}
                    loading={isFetchingTenants}
                    rows={gridPageData}
                    rowCount={gridRowCount}
                    rowHeight={40}
                    columnHeaderHeight={35}
                    disableColumnMenu={true}
                    hideFooter={true}
                    hideFooterPagination={true}
                    sx={{
                      fontFamily: "Honeywell Sans Web",
                      borderBlockColor: "black",
                      border: "black",
                      borderBlockEndColor: "black",
                      background: "#272727",
                      borderColor: "black",
                      fontSize: "0.8rem",
                    }}
                    localeText={customLocaleText}
                  />
                  {/* End Datagrid New */}
                </div>
              </Grid>
              <Grid
                container
                sx={{ border: "1px solid #101010" }}
                direction="row"
              >
                <Grid
                  item
                  sx={{
                    fontSize: "0.8rem",
                    width: "33.33% ",
                  }}
                ></Grid>

                <Grid
                  item
                  direction="row"
                  // justifyContent="center"
                  sx={{
                    background: "#272727",
                    width: "66.33% ",
                    display: "inline-flex",
                    padding: "1vh",
                    // verticalAlign: "center",
                  }}
                >
                  {/* <Grid sx={{ width: "13%" }}></Grid> */}
                  <Typography
                    sx={{
                      fontSize: "0.7rem",
                      width: "15%",
                      textAlign: "right",
                    }}
                  >
                    {paginationModel.page * paginationModel.pageSize -
                      paginationModel.pageSize +
                      1}
                    -{getPageEndCount()} of {gridRowCount}
                  </Typography>
                  <Pagination
                    defaultPage={1}
                    count={Math.ceil(gridRowCount / paginationModel.pageSize)}
                    page={paginationModel.page}
                    onChange={getPageValues}
                    sx={{
                      fontSize: "0.6rem",
                      width: "66%",
                      marginLeft: "1.5vw",
                      // "& .MuiPagination-ul": {
                      //   justifyContent: "center",
                      // },
                    }}
                  />
                  {/* <Grid sx={{ width: "33.33%" }}></Grid> */}
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </div>
      </Paper>

      {/* // Add Toast
            bar component and pass onClose for alert and open, onClose for snackbar //
            Add Dialog component and pass open, onClose for Dialog */}
      {open && (
        <DeleteDialog
          title="Delete Tenant"
          DeleteConfirmationMessage="Do you want to delete the tenant?"
          handleDeleteConfirmation={handleDeleteConfirmation}
          handleClose={handleClose}
          open={open}
        />
      )}
      {isLoading && <Loader />}
      {openDialogServerError && !isLoading && (
        <DialogForError
          open={openDialogServerError}
          onClose={onDialogForServerCloseHandler}
          errorList={errorList}
          errorType="serverError"
        />
      )}
      {/* /// Open NoURL error */}
      {openDialogNoURLError && !isLoading && (
        <DialogForError
          open={openDialogNoURLError}
          onClose={onDialogForNOURLCloseHandler}
          errorList={errorList}
          errorType="noURLFoundError"
        />
      )}
      {/* /// Open Toast error */}
      {openToastError && !isLoading && (
        <ToastBarForError
          open={openToastError}
          onClose={handleToastBarClose}
          errorList={errorList.concat(toastErrors.current)}
        />
      )}
    </>
  );
}

export default TenantListwithFilters;
